export default "/_next/static/media/Screen-Shot-2021-02-20-at-3.57.55-PM-1-614x1024.9892463212742eecae84b169e44dfaa9.png";